"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInfoBoxControlsState = exports.ControlState = void 0;
const selectors_1 = require("../selectors");
const useSelector_1 = require("./useSelector");
var ControlState;
(function (ControlState) {
    ControlState[ControlState["Disabled"] = -1] = "Disabled";
    ControlState[ControlState["Unselected"] = 0] = "Unselected";
    ControlState[ControlState["Selected"] = 1] = "Selected";
})(ControlState || (exports.ControlState = ControlState = {}));
const DEFAULT_CONTROLS_STATE = {
    enableIsolate: ControlState.Disabled,
    hidden: ControlState.Disabled,
    faded: ControlState.Disabled,
    hidingOthers: ControlState.Disabled,
    fadingOthers: ControlState.Disabled,
};
function useInfoBoxControlsState() {
    return (0, useSelector_1.useSelector)(selectors_1.selectControlsState) || DEFAULT_CONTROLS_STATE;
}
exports.useInfoBoxControlsState = useInfoBoxControlsState;
